import { AppNav } from '@/components/AppNav';
import { Footer } from '@/components/Footer';
import { Loader } from '@/components/Loader';
import { markdownComponents } from '@/components/Markdown/markdownComponents';
import { useGetPrivacyPolicyQuery } from '@/generated/graphql';
import Markdown from 'react-markdown';

export default function PrivacyPolicy() {
  const { data, loading } = useGetPrivacyPolicyQuery();
  const privacyPolicy = data?.privacyPolicy;

  return (
    <>
      <AppNav />
      <div
        data-name="PRIVACY_POLICY"
        className={`relative z-[2] mx-auto flex min-h-screen max-w-screen-md flex-col items-center justify-start`}
      >
        {loading ? (
          <div className="flex h-full w-full items-center justify-center">
            <Loader />
          </div>
        ) : (
          <Markdown className="text-left" components={markdownComponents}>
            {privacyPolicy}
          </Markdown>
        )}
      </div>
      <Footer />
    </>
  );
}
